import { render, staticRenderFns } from "./DistributeDownRecord.vue?vue&type=template&id=4a683dcc&"
import script from "./DistributeDownRecord.vue?vue&type=script&lang=js&"
export * from "./DistributeDownRecord.vue?vue&type=script&lang=js&"
import style0 from "./DistributeDownRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports